import { Justification, Result } from '../types';

export enum DefaultEventConstraint {
    EVENT_ATTENDEE_CONFLICT = 'EVENT_ATTENDEE_CONFLICT',
    EVENT_ATTENDEE_SOFT_CONFLICT = 'EVENT_ATTENDEE_SOFT_CONFLICT',
    EVENT_ATTENDEE_CONFLICT_BUFFER = 'EVENT_ATTENDEE_CONFLICT_BUFFER',
    EVENT_ATTENDEE_SOFT_CONFLICT_BUFFER = 'EVENT_ATTENDEE_SOFT_CONFLICT_BUFFER',
    EVENT_ATTENDEE_OVER_MEETING_LIMIT = 'EVENT_ATTENDEE_OVER_MEETING_LIMIT',
    EVENT_WITHIN_CALENDAR_AVAILABILITY = 'EVENT_WITHIN_CALENDAR_AVAILABILITY',
    EVENT_WITHIN_ATTENDEE_HOURS = 'EVENT_WITHIN_ATTENDEE_HOURS',
    EVENT_WITHIN_TEMPLATE_HOURS = 'EVENT_WITHIN_TEMPLATE_HOURS',
    GAPS_BETWEEN_MIN_AND_MAX = 'GAPS_BETWEEN_MIN_AND_MAX',
    REOCCURRING_ATTENDEE_IN_MEETING = 'REOCCURRING_ATTENDEE_IN_MEETING',
    EVENT_WITHIN_MEAL_HOURS = 'EVENT_WITHIN_MEAL_HOURS',
}

export enum GlobalEventConstraint {
    GAPS_BETWEEN_MIN_AND_MAX = 'GAPS_BETWEEN_MIN_AND_MAX',
}

export type EnumToMap<T> = {
    -readonly [K in keyof T]: T[K];
};

type DefaultEventConstraintMap = EnumToMap<typeof DefaultEventConstraint>;
type OptionalEventConstraintMap = EnumToMap<typeof GlobalEventConstraint>;
const defaultEventConstraintMap = Object.entries(DefaultEventConstraint).reduce(
    (map, [value, key]) => ({ ...map, [key]: value }),
    {} as DefaultEventConstraintMap,
);
const globalEventConstraintMap = Object.values(GlobalEventConstraint).reduce(
    (map, value) => ({ ...map, [value]: value }),
    {} as OptionalEventConstraintMap,
);

export const raConstraintsFilter = (result: Result): boolean => {
    const invalidResult = result.justifications.some(requestAvailabilityConflict);
    return (
        // searching for some justifications with valid RA conflict
        result.feasible && !invalidResult
    );
};

const requestAvailabilityConflict = (justification: Justification) =>
    // check if its a global conflict (aka conflict that applies to all events) or
    // is not a conflict of an optional attendee
    justification.id in globalEventConstraintMap || isEventWithConflict(justification);

const isEventWithConflict = (justification: Justification) => {
    const isOptionalAttendee = justification.items?.isOptionalAttendee === true;
    const isOptionalEvent = justification.items?.isOptionalEvent === true;
    return !(isOptionalEvent || isOptionalAttendee) && justification.id in defaultEventConstraintMap;
};
